import * as React from "react";
// Components
import { WelcomeBanner, BannerPositioning } from "./WelcomeBanner";
// Re-export for convenience
export { BannerPositioning };
/**
 * Container component that manages the Welcome banner state and dismissal
 */ export const WelcomeBannerContainer = ({ positioning })=>{
    const [isDismissed, setIsDismissed] = React.useState(false);
    const handleDismiss = React.useCallback(()=>{
        setIsDismissed(true);
    }, []);
    // Don't render anything if the banner has been dismissed
    if (isDismissed) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(WelcomeBanner, {
        onDismiss: handleDismiss,
        positioning: positioning
    });
};
